<div ngClass.lt-sm="m-t-xl" ngClass.sm="m-t-xl" *ngIf="!preview">
	<div fxFlex="100%">
		<div class="mat-subtitle-2 p-b-m">
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/visibilityOn/public"
			/>
			<span
				fxFlex.gt-md="40%"
				fxLayoutAlign.gt-md="start center"
				fxFlexOffset="8px"
				*ngIf="type === 'fundraiser'"
				i18n="@@shareFundraiserPage_fundraiserPagePreview_label"
			>
				Fundraiser Page Preview
			</span>
			<span
				fxFlexOffset="8px"
				*ngIf="type === 'donate'"
				i18n="@@shareFundraiserPage_donationPagePreview_label"
			>
				Donate Page Preview
			</span>
			<span
				fxFlexOffset="8px"
				*ngIf="type === 'paymentRequest' || type === 'ownWebsite'"
				i18n="@@embed_donationFormPreview_icon"
			>
				Donation Form Preview
			</span>
		</div>
		<div fxLayoutAlign="center" class="grey-bg p-m">
			<ng-container
				*ngIf="type === 'fundraiser'"
				[ngTemplateOutlet]="fundraiserPreview"
			>
			</ng-container>
			<ng-container
				*ngIf="type === 'donate'"
				[ngTemplateOutlet]="donationFormPreview"
			></ng-container>
			<ng-container
				*ngIf="type === 'paymentRequest'"
				[ngTemplateOutlet]="paymentRequest"
			>
			</ng-container>
			<div *ngIf="type === 'ownWebsite'" fxFlex="90%" fxFlex.sm="55%">
				<ng-container
					*ngIf="type === 'ownWebsite'"
					[ngSwitch]="previewSwitchCase"
				>
					<ng-container
						*ngSwitchCase="'donation-widget'"
						[ngTemplateOutlet]="widget"
					></ng-container>
					<ng-container
						*ngSwitchCase="'show-with-image'"
						[ngTemplateOutlet]="widgetImage"
					></ng-container>
					<ng-container
						*ngSwitchCase="'donation-form+widget'"
						[ngTemplateOutlet]="form"
					></ng-container>
					<ng-container
						*ngSwitchCase="'donation-form+image'"
						[ngTemplateOutlet]="formImage"
					></ng-container>
					<ng-container
						*ngSwitchCase="'donation-button'"
						[ngTemplateOutlet]="donationButton"
					></ng-container>
					<ng-container
						*ngSwitchDefault
						[ngTemplateOutlet]="widget"
					></ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</div>

<!-- Preview Templates: Templates for showing Preview -->
<ng-template #widget>
	<mat-card
		[ngStyle]="{
			'box-shadow': boxShadow,
			'font-family': embedPreviewData?.fontFamily
		}"
		class="donation-form-preview"
	>
	    <mat-card-content>
			<ng-container [ngTemplateOutlet]="widgetBody"></ng-container>
			<ng-container [ngTemplateOutlet]="donationButtonBody"></ng-container>
		</mat-card-content>
	</mat-card>
</ng-template>

<ng-template #imageVideo>
	<!-- Display image if available -->
	<img
		mat-card-image
		*ngIf="fundraiserBackgroundImage != '' && fundraiserBackgroundVideo == ''"
		[src]="fundraiserBackgroundImage"
		loading="lazy"
	/>
	<!-- Display video if available or both image and video are available -->
	<img
		mat-card-image
		i18n="@@fundraiserCard_createBackgroundImage"
		*ngIf="
			fundraiserBackgroundVideo ||
			(fundraiserBackgroundImage != '' && fundraiserBackgroundVideo)
		"
		src="{{ this.youtubeThumbnail }}"
		loading="lazy"
	/>
	<!-- Display a default image if none of the above conditions are met -->
	<img
		mat-card-image
		*ngIf="!fundraiserBackgroundImage && !fundraiserBackgroundVideo"
		src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fundraiser_default_bg/public"
		loading="lazy"
	/>
</ng-template>

<ng-template #widgetImage>
	<mat-card
		[ngStyle]="{
			'box-shadow': boxShadow,
			'font-family': embedPreviewData?.fontFamily
		}"
		class="donation-form-preview"
	>
	    <mat-card-content>
			<ng-container [ngTemplateOutlet]="imageVideo"></ng-container>
			<ng-container [ngTemplateOutlet]="widgetBody"></ng-container>
			<ng-container [ngTemplateOutlet]="donationButtonBody"></ng-container>
		</mat-card-content>
	</mat-card>
</ng-template>
<ng-template #form>
	<mat-card
		[ngStyle]="{
			'box-shadow': boxShadow,
			'font-family': embedPreviewData?.fontFamily
		}"
		class="donation-form-preview"
	>
	    <mat-card-content>
			<ng-container [ngTemplateOutlet]="widgetBody"></ng-container>
			<ng-container [ngTemplateOutlet]="formBody"></ng-container>
			<ng-container [ngTemplateOutlet]="donationButtonBody"></ng-container>
		</mat-card-content>
	</mat-card>
</ng-template>
<ng-template #formImage>
	<mat-card
		[ngStyle]="{
			'box-shadow': boxShadow,
			'font-family': embedPreviewData?.fontFamily
		}"
		class="donation-form-preview"
	>
	    <mat-card-content>
			<ng-container [ngTemplateOutlet]="imageVideo"></ng-container>
			<ng-container [ngTemplateOutlet]="widgetBody"></ng-container>
			<ng-container [ngTemplateOutlet]="formBody"></ng-container>
			<ng-container [ngTemplateOutlet]="donationButtonBody"></ng-container>
		</mat-card-content>
	</mat-card>
</ng-template>
<ng-template #donationButton>
	<ng-container [ngTemplateOutlet]="donationButtonBody"></ng-container>
</ng-template>

<!-- Body Template: used with combinations inside the Preview Templates -->
<ng-template #widgetBody>
	<div class="donation-form-preview">
		<app-amount-view
			[fundraiserCardData]="this.amountProgressData?.data"
			[symbol]="this.currency_symbol"
		></app-amount-view>
		<br /><br />
		<app-donation-progress-bar
			[fundraiserCardData]="this.amountProgressData?.data"
		></app-donation-progress-bar>
		<br />
	</div>
</ng-template>
<ng-template #formBody>
	<div class="donation-form-preview">
		<mat-tab-group mat-stretch-tabs color="accent">
			<mat-tab label="{{ oneTimeLabel }}">
				<div fxLayoutAlign="center" fxLayout="row wrap" ngClass="m-b-m">
					<div class="p-t-s">
						<button mat-flat-button color="primary">
							{{ this.currency_symbol }}
							{{ this.onetime_first | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.onetime_second | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.onetime_third | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.onetime_forth | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
				</div>
			</mat-tab>
			<mat-tab label="{{ monthlyLabel }}">
				<div fxLayoutAlign="center" fxLayout="row wrap" ngClass="m-b-m">
					<div class="p-t-s">
						<button mat-flat-button color="primary">
							{{ this.currency_symbol }}
							{{ this.monthly_first | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.monthly_second | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.monthly_third | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.monthly_forth | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
				</div>
			</mat-tab>
			<mat-tab label="{{ yearlyLabel }}">
				<div fxLayoutAlign="center" fxLayout="row wrap" ngClass="m-b-m">
					<div class="p-t-s">
						<button mat-flat-button color="primary">
							{{ this.currency_symbol }}
							{{ this.yearly_first | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.yearly_second | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.yearly_third | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
					<div class="p-t-s">
						<button mat-stroked-button>
							{{ this.currency_symbol }}
							{{ this.yearly_forth | number }}</button
						>&nbsp;&nbsp;&nbsp;
					</div>
				</div>
			</mat-tab>
		</mat-tab-group>

		<br />
	</div>
</ng-template>
<ng-template #donationButtonBody>
	<p class="donation-form-preview">
		<button
			fxFlex
			mat-flat-button
			[style.border-radius]="embedPreviewData?.buttonRadius + 'px'"
			[style.font-family]="embedPreviewData?.fontFamily"
			color="accent"
			i18n="@@button_donate"
		>
			Donate
		</button>
	</p>
</ng-template>

<ng-template #fundraiserPreview>
	<div>
		<div fxFlex.lt-sm="100%">
			<img
				ngClass.lg="m-r-l"
				fxLayoutAlign.gt-md="end center"
				fxFlex.gt-md="110"
				class="w-100"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fundraiserpage/public"
			/>
		</div>
	</div>
</ng-template>

<ng-template #donationFormPreview>
	<div>
		<mat-card
			fxLayout="row"
			fxLayout.lt-sm="row wrap"
			fxFlex.lt-sm="100%"
			class="donation-form-preview"
			fxLayoutAlign="center"
		>
		    <mat-card-content>
				<div fxFlex.lt-sm="100%" fxFlex="60">
					<mat-tab-group>
						<mat-tab label="{{ oneTimeLabel }}">
							<div fxLayout="row wrap" fxLayoutAlign="center">
								<div class="p-t-s">
									<button mat-flat-button color="primary">
										{{ this.currency_symbol }}
										{{ this.onetime_first | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }}
										{{ this.onetime_second | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }}
										{{ this.onetime_third | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }} {{ this.onetime_forth | number }}
									</button>
								</div>
							</div>
							<br />
						</mat-tab>
						<mat-tab label="{{ monthlyLabel }}">
							<div fxLayout="row wrap" fxLayoutAlign="center">
								<div class="p-t-s">
									<button mat-flat-button color="primary">
										{{ this.currency_symbol }}
										{{ this.monthly_first | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }}
										{{ this.monthly_second | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }}
										{{ this.monthly_third | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }} {{ this.monthly_forth | number }}
									</button>
								</div>
							</div>
							<br />
						</mat-tab>
						<mat-tab label="{{ yearlyLabel }}">
							<div fxLayout="row wrap" fxLayoutAlign="center">
								<div class="p-t-s">
									<button mat-flat-button color="primary">
										{{ this.currency_symbol }}
										{{ this.yearly_first | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }}
										{{ this.yearly_second | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }}
										{{ this.yearly_third | number }}</button
									>&nbsp;&nbsp;&nbsp;
								</div>
								<div class="p-t-s">
									<button mat-stroked-button>
										{{ this.currency_symbol }} {{ this.yearly_forth | number }}
									</button>
								</div>
							</div>
							<br />
						</mat-tab>
					</mat-tab-group>
					<br />
					<div
						fxLayout="column"
						fxLayout.lt-sm="row"
						fxLayoutAlign="center center"
						ngClass.lt-sm="m-b-l"
					>
						<br />
						<button mat-flat-button color="accent" i18n="@@button_donate">
							Donate
						</button>
					</div>
				</div>
				<mat-divider vertical="true" fxHide.lt-sm></mat-divider>
				<div fxLayout="column" fxFlex.lt-sm="95%" fxFlex="40">
					<!-- Display image if available -->
					<img
						*ngIf="
							fundraiserBackgroundImage != '' && fundraiserBackgroundVideo == ''
						"
						[src]="fundraiserBackgroundImage"
						loading="lazy"
					/>
					<!-- Display video if available or both image and video are available -->
					<img
						i18n="@@fundraiserCard_createBackgroundImage"
						*ngIf="
							fundraiserBackgroundVideo ||
							(fundraiserBackgroundImage != '' && fundraiserBackgroundVideo)
						"
						src="{{ this.youtubeThumbnail }}"
						loading="lazy"
					/>
					<!-- Display a default image if none of the above conditions are met -->
					<img
						*ngIf="!fundraiserBackgroundImage && !fundraiserBackgroundVideo"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fundraiser_default_bg/public"
						loading="lazy"
					/>
					<br />

					<img
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/custom-donation/public"
					/>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</ng-template>

<ng-template #paymentRequest>
	<div fxLayout="column">
		<mat-card>
			<mat-card-content ngClass="p-m">
				<p fxLayoutAlign="center" class="mat-headline-5">
					{{ currency_symbol }}
					{{ selectedAmount || '- - -' }}
				</p>
				<br />
				<p fxLayout="row" fxLayoutAlign="space-between center">
					&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/visa/public"
					/>&nbsp;&nbsp;&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/master-card/public"
					/>&nbsp;&nbsp;&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/bancontact/public"
					/>&nbsp;
				</p>
				<p fxLayout="row" fxLayoutAlign="space-between center">
					&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/sofort/public"
					/>&nbsp;&nbsp;&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/ideal/public"
					/>&nbsp;&nbsp;&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/paypal/public"
					/>&nbsp;
				</p>
				<p fxLayout="row" fxLayoutAlign="space-between center">
					&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/belfius/public"
					/>&nbsp;&nbsp;&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/kbc/public"
					/>&nbsp;&nbsp;&nbsp;
					<img
						class="logos"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/eps/public"
					/>&nbsp;
				</p>
				<br />
				<p fxLayoutAlign="center">
					<button mat-flat-button color="accent" i18n="@@button_pay">
						Pay
					</button>
				</p>
			</mat-card-content>
		</mat-card>
		<mat-hint
			class="mat-caption"
			i18n="@@paymentRequest_actualPaymentScreen_hint"
			>NOTE: Actual payment screen may vary
		</mat-hint>
	</div>
</ng-template>
